import React, { Fragment, PureComponent } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { Link } from 'react-router-dom'

import Button from '@UniformComponents/Button'
import DataTable from '../../../DataTable'
import SearchInput from '../../../Search'

@observer
class Search extends PureComponent {
    tableColumns = []

    componentDidMount() {
        const { store } = this.props
        this.setColumns()
        store.initSearch()
    }

    setColumns = () => {
        const { store } = this.props
        const levels = store.getLevels()

        this.tableColumns = [
            {
                name: 'id',
                key: 'id',
            },
            {
                name: i18n.t('customTag.edit.name'),
                key: 'name',
            },
            {
                name: i18n.t('customTag.edit.level'),
                key: 'oid',
                dataTransform: (oid) => (
                    levels
                        .filter(({ value }) => value === oid)
                        .map(({ label }) => label)
                ),
            },
            {
                name: i18n.t('client'),
                key: 'clientId',
            },
            {
                name: i18n.t('industry'),
                key: 'industry',
            },
            {
                name: i18n.t('product_type'),
                key: 'productType',
            },
            {
                name: i18n.t('survey_type'),
                key: 'surveyType',
            },
            {
                name: i18n.t('respondent_type'),
                key: 'respondentType',
            },
            {
                name: i18n.t('customTag.edit.options'),
                key: 'options',
            },
            {
                name: '',
                key: 'id',
                dataTransform: (id) => (
                    <Link style={{ fontSize: '22px' }} className="fal fa-edit" to={`/intranet/customTag/${id}`} onClick={(e) => e.stopPropagation()} />),
            },
            {
                name: '',
                key: 'id',
                dataTransform: (id) => (
                    <i
                        style={{ fontSize: '22px' }}
                        className="fal fa-trash-alt"
                        onClick={(e) => {
                            e.stopPropagation()
                            store.delete(id)
                        }}
                    />
                ),
            },
        ]
    }

    renderDataTable = () => {
        const { history, store } = this.props
        const { searchData, isCustomBenchmark } = store

        const tableArgs = {
            data: searchData,
            columns: this.tableColumns,
            rowClick: (e, id) => { history.push(`/intranet/${isCustomBenchmark ? 'customBenchmark' : 'customTag'}/${id}`) },
            rowId: 'id',
            emptyMessage: i18n.t('datatable.noRecords'),
        }

        if (tableArgs.data.length > 0) {
            return (
                <DataTable
                    store={{ filteredList: tableArgs.data }}
                    dataSet={tableArgs.data}
                    columns={tableArgs.columns}
                    rowClick={tableArgs.rowClick}
                    rowId={tableArgs.rowId}
                    inMemory
                />
            )
        }
        return <div>{tableArgs.emptyMessage}</div>
    }

    goToNew = () => {
        const { history, store } = this.props
        const { isCustomBenchmark } = store
        history.push(`/intranet/${isCustomBenchmark ? 'customBenchmark' : 'customTag'}/0`)
    }

    render() {
        const { store } = this.props
        const { isLoading, isCustomBenchmark } = store

        return (
            <Fragment>
                {!isLoading && (
                    <Fragment>
                        <div>
                            <Button
                                type="button"
                                label={i18n.t(`${isCustomBenchmark ? 'customBenchmark' : 'customTag'}.search.new`)}
                                onClick={this.goToNew}
                                cssClass="regular primary"
                            />
                        </div>
                        <SearchInput
                            ref={(s) => { store.searchModule = s }}
                            onSearch={store.filter}
                        />
                        {this.renderDataTable()}
                    </Fragment>
                )}
            </Fragment>
        )
    }
}

export default Search
